import React, { createContext, useContext, useMemo } from 'react';
import { createI18n, defaultNamespace } from '../createI18n';
import { useLocale } from './useLocale';
const defaultI18n = createI18n();
export const I18NContext = createContext(defaultI18n);
export function useT(_namespace = defaultNamespace) {
    const [, forceRender] = React.useReducer(state => state + 1, 1);
    const locale = useLocale();
    const i18n = useContext(I18NContext);
    const namespace = defaultNamespace;
    const [clone, loading] = React.useMemo(() => {
        const _clone = i18n.cloneInstance();
        _clone.changeLanguage(locale);
        return [
            _clone,
            _clone.loadNamespaces(namespace),
        ];
    }, [i18n, locale, namespace]);
    const isLoading = !clone.hasResourceBundle(locale, namespace);
    React.useEffect(() => {
        if (isLoading)
            loading.then(forceRender);
    }, [isLoading, loading]);
    return useMemo(() => {
        return createT(clone, isLoading, loading);
    }, [clone, isLoading, loading]);
}
function createT(i18n, isLoading, loading) {
    const _t = i18n.t.bind(i18n);
    function wrappedT(id, stringValue, _description, interpolatedValues = {}) {
        return _t(id, stringValue, interpolatedValues);
    }
    wrappedT.read = function read() {
        if (isLoading)
            throw loading;
        return wrappedT;
    };
    return wrappedT;
}
export const mockT = createT(defaultI18n, false, Promise.resolve());
export function withT(ClassComponent) {
    return function WithT(props) {
        const t = useT();
        return React.createElement(ClassComponent, Object.assign({}, props, { t: t }));
    };
}
//# sourceMappingURL=useT.js.map